import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils'
import {
  ProgressIndicator,
  ProgressRoot,
  type ProgressRootProps,
} from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Progress',
  props: {
    modelValue: { default: 0 },
    max: {},
    getValueLabel: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(__props: any) {

const props = __props

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ProgressRoot), _mergeProps(delegatedProps.value, {
    class: 
      _unref(cn)(
        'relative h-4 w-full overflow-hidden rounded-full bg-secondary',
        props.class,
      )
    
  }), {
    default: _withCtx(() => [
      _createVNode(_unref(ProgressIndicator), {
        class: "h-full w-full flex-1 bg-primary transition-all",
        style: _normalizeStyle(`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`)
      }, null, 8, ["style"])
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})